var React = require('react');

function LogoTw (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#393939","fillRule":"nonzero","d":"M15.889 0C7.128 0 0 7.128 0 15.889c0 8.76 7.128 15.888 15.889 15.888 8.76 0 15.888-7.128 15.888-15.888C31.777 7.128 24.65 0 15.89 0zm7.088 12.252c.007.158.01.316.01.475 0 4.833-3.677 10.403-10.405 10.403-2.066 0-3.988-.603-5.606-1.641.286.034.577.05.872.05a7.34 7.34 0 0 0 4.542-1.565 3.66 3.66 0 0 1-3.416-2.54 3.686 3.686 0 0 0 1.651-.061 3.658 3.658 0 0 1-2.933-3.586v-.046a3.642 3.642 0 0 0 1.656.457 3.654 3.654 0 0 1-1.626-3.043c0-.671.18-1.3.495-1.84a10.384 10.384 0 0 0 7.537 3.822 3.657 3.657 0 0 1 6.232-3.336 7.3 7.3 0 0 0 2.323-.888 3.673 3.673 0 0 1-1.61 2.024 7.27 7.27 0 0 0 2.1-.575 7.356 7.356 0 0 1-1.822 1.89z"}));
}

LogoTw.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LogoTw;

LogoTw.default = LogoTw;
